import Cookie from 'js-cookie'
import VirtualPath from 'meta/utils/virtualPath'

function writeCookie(name, value) {
    Cookie.set(name, value, {path: VirtualPath + '/'})
}

// Positive IDs for all pages
function CheckPosIdTimeDT() {
    var posId = GetPosId().getTime()
    var PosIdInterval = GetPosIdInterval()
    var validTill = new Date(posId + PosIdInterval)
    return validTill
}

function GetPosId() {
    var i = new Date(parseInt(Cookie.get("PosId")))
    if (isNaN(i)) { i = new Date(0) }

    return i
}

function GetPosIdInterval() {
    var n = parseInt(Cookie.get("PosIdInt"))
    if (isNaN(n)) {
        n = 60000; //default is 60secs
        writeCookie('PosIdInt', n)
    }
    // alert("GetPosIdInterval="+n.toString());
    return n
}

function CheckPosId() {
    var now = new Date();
    var validTill = CheckPosIdTimeDT()
    return (now < validTill);
}

function CheckPosIdTime() {
    var now = new Date();
    var validTill = CheckPosIdTimeDT()
    //alert(validTill-now);
    return (validTill - now)
}

function SetPosId() {
    var now = new Date();
    var validTill = CheckPosIdTimeDT()
    if (validTill.getTime() < now.getTime() + 86400000) // not to overwrite without badge
    {
        writeCookie('PosId', now.getTime().toString())
    }
}

function GetLastActivity() {
    var i = new Date(parseInt(Cookie.get("LastActivity")))
    if (isNaN(i)) i = new Date(0)

    return i
}
function GetLastActivityInterval() {
    var n = parseInt(Cookie.get("LastActivityInt"))
    if (isNaN(n)) {
        n = 60000 //default is 60secs
        writeCookie('LastActivityInt', n)
    };

    return n
}
function CheckLastActivityDT() {
    var LastActivity = GetLastActivity().getTime()
    var LastActivityInterval = GetLastActivityInterval()
    var validTill = new Date(LastActivity + LastActivityInterval)
    return validTill;
}
function CheckLastActivity() {
    var now = new Date()
    var validTill = CheckLastActivityDT()
    return (now < validTill)
}

export {
    writeCookie,
    CheckPosIdTimeDT,
    GetPosId,
    GetPosIdInterval,
    CheckPosIdTime,
    CheckPosId,
    SetPosId,
    GetLastActivity,
    GetLastActivityInterval,
    CheckLastActivityDT,
    CheckLastActivity
}
